

































import { namespace } from 'vuex-class';
import { Component, Watch, Vue } from 'vue-property-decorator';

import Heading from '@/shared/components/Heading/Heading.vue';
import PaymentMethods from './components/PaymentMethods/PaymentMethods.vue';
import DeliveryAddress from './components/DeliveryAddress/DeliveryAddress.vue';
import SecureSection from '@/shared/components/SecuredSection/SecuredSection.vue';
import SystemError from './components/ErrorSystem/SystemError.vue';

import { ICheckoutCartOffer } from '@/interfaces/Checkout';

import Address from '@/classes/Address';

const BehaviorModule = namespace('App/Behavior');
const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Heading,
    PaymentMethods,
    DeliveryAddress,
    SystemError,
    SecureSection,
  }
})
export default class Payment extends Vue {
  $refs!: {
    deliveryAddress: DeliveryAddress
  };

  @CheckoutModule.State(state => state.checkout.cart.offer)
  private offer: ICheckoutCartOffer;

  @CheckoutModule.Getter('isAddressRequired')
  private isAddressRequired: boolean;

  @CustomerModule.Getter('deliveryAddress')
  private readonly deliveryAddress: Address;

  @BehaviorModule.Mutation('setDeliveryAddressValid')
  private setDeliveryAddressValid: Function;

  private async validateDeliveryAddress() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.$refs.deliveryAddress.validateAddress();

        this.setDeliveryAddressValid(true);

        resolve(true);
      } catch (e) {
        this.setDeliveryAddressValid(false);

        reject(false);
      }
    });
  }

  private get ABSecurity() {
    return this.$route.query.s === '1';
  }

  private get showMessageErrorSystem(){
    return process.env.VUE_APP_ENABLE_PAYMENT_MESSAGE_ERROR_SYSTEM === 'true';
  }

  private get isEmpiricusGift() {
    return this.$route.query.g === '1';
  }

  private get headingText() {
    return this.isEmpiricusGift ? 'Seja bem-vindo à Empiricus' : 'Como deseja pagar?';
  }
}
